export const NEEDS_DESIGN_STYLES = {
  color: "hotpink",
  fontFamily: "chalkboard",
}
